module.exports = __webpack_public_path__ + "img/max-file-configure--json.2a26dda1.svg";